import { replaceTokens } from '@sleepstation/utils'
import { pipe } from 'ramda'
import { compact } from 'ramda-adjunct'

const { joinWithSpace } = require(`@sleepstation/utils`)

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const CREDIT_TEMPLATE = `By #{name}`

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const addCredit = replaceTokens(CREDIT_TEMPLATE)

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

// eslint-disable-next-line import/prefer-default-export
export const formatAuthorNameWithHonorific = ({
  honorific,
  forename,
  surname,
}) => pipe(compact, joinWithSpace)([honorific, forename, surname])

export const formatAuthorCredit = pipe(formatAuthorNameWithHonorific, (name) =>
  addCredit({ name })
)
